export const COOKIE_ANONYMOUS_ID = 'CS_ANONYMOUS_ID';

export const RESPONSE_REQUIRES_2FA = '2fa_required';
